import {useEffect, useState} from 'react'

export type UseImageResult = {
  image: HTMLImageElement | null
  width: number
  height: number
  isLoaded: boolean
}

function useImage(src: string | undefined | null): UseImageResult {
  const [state, setState] = useState<UseImageResult>({
    image: null,
    width: 0,
    height: 0,
    isLoaded: false,
  })

  useEffect(() => {
    if (!src) {
      setState({image: null, width: 0, height: 0, isLoaded: false})
      return
    }

    const img = new Image()
    const handleLoad = () => {
      setState({
        image: img,
        width: img.naturalWidth,
        height: img.naturalHeight,
        isLoaded: true,
      })
    }

    img.addEventListener('load', handleLoad)
    img.src = src

    if (img.complete) {
      handleLoad()
    }

    return () => {
      img.removeEventListener('load', handleLoad)
    }
  }, [src])

  return state
}

export default useImage
